export const SAVINGS_RECEIVED = 'SAVINGS_RECEIVED'
export const SAVINGS_ASOF_RECEIVED = 'SAVINGS_ASOF_RECEIVED'
export const SAVINGS_UNLOADED = 'SAVINGS_UNLOADED'

export const SAVINGS_SAVED = 'SAVINGS_SAVED'
export const SAVINGS_DELETED = 'SAVINGS_DELETED'
